
// this functions turns 1234 into 1000
function getSimpleValue(value) {
  const zerosCount = Math.floor(Math.log(value) / Math.log(10));
  const oneWithZeros = Math.pow(10, zerosCount);
  return Math.floor(value / oneWithZeros) * oneWithZeros;
}

// examples:
// getFilesSizeString(15 * 1024 ** 4) === '10+ Terabytes'
// getFilesSizeString(115 * 1024 ** 4) === '100+ Terabytes'
// getFilesSizeString(15 * 1024 ** 3) === '15 Gigabytes'
// getFilesSizeString(115 * 1024 ** 3) === '115 Gigabytes'
export function getFilesSizeString(sizeInBytes) {
  // when the data is not ready, showing `1 Bytes` is better than showing `NaN Bytes`
  sizeInBytes = sizeInBytes || 1;
  const k = 1024;
  const terabyte = k ** 4;
  const sizes = ['B', 'Kilob', 'Megab', 'Gigab', 'Terab', 'Petab'];
  const i = Math.floor(Math.log(sizeInBytes) / Math.log(k));
  const value = Math.floor(sizeInBytes / Math.pow(k, i));
  const size = sizes[i] + 'ytes';
  if (sizeInBytes > terabyte) {
    return `${getSimpleValue(value)}+ ${size}`;
  }
  return `${value} ${size}`;
}
